// 采购单

import React from "react";
import { ISearchValue, SearchTypeEnum } from "@/components/YhPageHeader/Types";
import { YhPageHeader } from "@/components/YhPageHeader";
import { useInquiryResultModel } from "../inquiryResultModel";
import { inquiryStatusOption } from "@/types/supplierDs";


export function PageHeader() {
    
    const {
        searchParam,
        updateSearchParam,
        resetSearchParam,
        loadData
    } = useInquiryResultModel();

    const searchFields = [
        {
            type: SearchTypeEnum.Input,
            placeholder: "单号",
            fieldName: "resultCode",
        },
        
    ]

    return (
        <>
            <YhPageHeader
                title="询价对比结果列表"
                size="small"
                searchValues={searchParam as ISearchValue}
                searchFields={searchFields}
                onChange={updateSearchParam}
                triggerSearch
                handleSearch={(val = {}) => loadData({ pageNum: 1 }, { ...searchParam, ...val })}
                handleReset={resetSearchParam}
            />
        </>
    );
}